export default __webpack_public_path__ + "static/media/sticker.e05ecb70.svg";